export class DatiVersionamentoDocumentoDTO {
    versione: string;

    data: string;

    idVersionePrecedente: string;

    idVersioneSuccessiva: string;
}
